import { WIDGET_EVENTS } from './constants';

export class ErrorHandler {
  // eslint-disable-next-line class-methods-use-this
  handleError(error, action, context = {}) {
    const errorMessage = error instanceof Error ? error.message : String(error);

    try {
      window.dispatchEvent(
        new CustomEvent(WIDGET_EVENTS.ERROR, {
          detail: {
            error: errorMessage,
            action,
            context,
            timestamp: Date.now(),
          },
        })
      );
    } catch (dispatchError) {
      // eslint-disable-next-line no-console
      console.error(
        '[LimeChat Widget] Failed to dispatch error event:',
        dispatchError
      );
    }
  }

  // eslint-disable-next-line class-methods-use-this
  reset() {
    // eslint-disable-next-line no-console
    console.info('[LimeChat Widget] Error handler reset');
  }
}
